(() => {
  if (document.documentElement.dataset.smNavigationBound) return;
  document.documentElement.dataset.smNavigationBound = 'true';
  const menus = '.header .nav > details, .header .mobilemenu';
  let boundsQueued = false;
  function queueMenuBounds() {
    if (boundsQueued || !document.querySelector('.header .mobilemenu[open]')) return;
    boundsQueued = true;
    window.requestAnimationFrame(() => {
      boundsQueued = false;
      const viewportBottom = (window.visualViewport?.height || window.innerHeight) + (window.visualViewport?.offsetTop || 0);
      document.querySelectorAll('.header .mobilemenu[open] .mobilepanel').forEach(panel => {
        const available = Math.max(0, Math.floor(viewportBottom - panel.getBoundingClientRect().top - 8));
        panel.style.setProperty('max-height', available + 'px', 'important');
      });
    });
  }
  window.addEventListener('resize', queueMenuBounds, {passive:true});
  window.addEventListener('scroll', queueMenuBounds, {passive:true});
  window.visualViewport?.addEventListener('resize', queueMenuBounds, {passive:true});
  window.visualViewport?.addEventListener('scroll', queueMenuBounds, {passive:true});

  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.matches(menus) || !menu.open) return;
    document.querySelectorAll(menus).forEach((other) => {
      if (other !== menu) other.open = false;
    });
    queueMenuBounds();
  }, true);
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    document.querySelectorAll(menus).forEach((menu) => {
      if (menu.open && (!menu.contains(event.target) || (link && menu.contains(link)))) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const header = event.target.closest('.header');
    const menu = event.target.closest('details[open]');
    if (!header || !menu || !header.contains(menu)) return;
    menu.open = false;
    event.preventDefault();
    event.stopPropagation();
    menu.querySelector(':scope > summary')?.focus();
  });
})();
